import { i18n } from '@/lang/i18n';
import { environmentService, postRequestHandler, getRequestHandler } from '@/utils/services';
import { compressToUTF16 as compress, decompressFromUTF16 as decompress } from 'lz-string';
import { DialogProgrammatic as Dialog } from 'buefy'

const axios = require('axios');

const DefaultState = () => {
  return {
    apiUrlHotel: null,
    apiUrlBooking: null,
    hotels: [],
    hotelsByUser: [],
    categories: null,
    isHotelLoading: false,
    isHotelReady: false,
    isHotelCreate: false,
    isRoomTypeLoading: false,
    isLoading: false,
    ammenities: null,
    showHotelInObservation: false,
    selectedHotel: null,
    roomtypes: [],
    bedOptions: null,
    contactListUpdate:false,
    imagesUpdate:{
      done:false,
      data:{},
      action:''
    },
    updateFlag:0,
    updateHotelFinished:false,
    contactListData:[],
    isUploading:false,
    childspolicies: [],
    policies:[],
    showBtnHotelUpdate:false,
    hotelCreation:{
      done:false,
      id:null
    },
    gridUpdate:false,
    total:0,
  };
},

      state = DefaultState(),

      getters = {
        hotels: state => state.hotels,
        ammenities: state => state.ammenities,
        categories: state => state.categories,
        hotelsByUser: state => state.hotelsByUser,
        isHotelLoading: state => state.isHotelLoading,
        isHotelReady: state => state.isHotelReady,
        isHotelCreate: state => state.isHotelCreate,
        isLoading: state => state.isLoading,
        isUploading: state => state.isUploading,
        showHotelInObservation: state => state.showHotelInObservation,
        selectedHotel: state => state.selectedHotel,
        roomtypes: state => state.roomtypes,
        bedOptions: state => state.bedOptions,
        policies: state => state.policies,
        showBtnHotelUpdate: state  => state.showBtnHotelUpdate,
        childspolicies: state => state.childspolicies,
        isRoomTypeLoading: state => state.isRoomTypeLoading,
        updateHotelFinished: state => state.updateHotelFinished,
        contactListUpdate: state => state.contactListUpdate,
        contactListData: state => state.contactListData,
        imagesUpdate: state => state.imagesUpdate,
        hotelCreation: state => state.hotelCreation,
        updateFlag: state => state.updateFlag,
        gridUpdate: state => state.gridUpdate,
        total: state => state.total,
      },

      mutations = {
        setHotels(state, payload) {
          state.hotels = payload;
        },
        setSelectedHotel(state, payload) {
          state.selectedHotel = payload;
        },
        setGridUpdate(state, payload){
          state.gridUpdate = payload;
        },
        setHotelCreation(state, payload){
          if (payload == false){
            state.hotelCreation.done = false;
            state.hotelCreation.id = null;
            state.updateHotelFinished = true;
          } else {
            state.hotelCreation.done = true;
            state.hotelCreation.id = payload;
          }
        },
        setChildsPolicies(state, payload) {
          state.childspolicies = payload;
        },
        setChildsPoliciesUrls(state) {
          state.apiUrlHotel = environmentService.apiUrlHotel;
        },
        setContactListUpdate(state, payload){
          if (payload == false) {
            state.contactListUpdate = false;
            state.contactListData = {};
          } else {
            state.contactListUpdate = true;
            state.contactListData = payload;
            let hotelIndex = state.hotelsByUser.findIndex(hotel => hotel.id == payload[0].hotel_id);
            state.hotelsByUser[hotelIndex].contacts = payload;
          }
        },
        setImagePrimaryUpdate(state, payload){
          let hotelIndex = state.hotelsByUser.findIndex(hotel => hotel.id == payload.hotelId);
          let imageIndex = state.hotelsByUser[hotelIndex].images.findIndex(images => images.id == payload.imageId)

          if (state.hotelsByUser[hotelIndex].images.length > 0) {
            let LastImagePrimaryIndex = state.hotelsByUser[hotelIndex].images.findIndex(images => images.is_primary == true)
            if (LastImagePrimaryIndex >= 0) {
              state.hotelsByUser[hotelIndex].images[LastImagePrimaryIndex].is_primary = false;
            }

            if (imageIndex >= 0) {
              state.hotelsByUser[hotelIndex].images[imageIndex].is_primary = true;
            } else {
              state.hotelsByUser[hotelIndex].images[0].is_primary = true;
            }
          }
        },
        setImageUpdate(state, payload) {
          if (payload == false) {
            state.imagesUpdate.action = '';
            state.imagesUpdate.done = false;
            state.imagesUpdate.data = [];
          } else {
            state.imagesUpdate.done = true;
            state.imagesUpdate.action = payload.action;
            if (payload.action == 'create') {
              state.imagesUpdate.data = payload.data.data.data;
            } else {
              state.imagesUpdate.data = payload.data.data.data.images;
            }
          }
        },
        updatesPrimary(state, payload) {
          // Makes first image primary if old primary has been deleted
          if (state.hotelsByUser[payload].images.length > 0 ) {
            state.hotelsByUser[payload].images[0].isPrimary = true;
          }
        },
        toggleUploading(state, payload) {
          state.isUploading = payload;
        },
        setUpdateHotelFinished(status, payload) {
          status.updateHotelFinished = payload;
        },
        setHotelsUrls(state) {
          state.apiUrlHotel = environmentService.apiUrlHotel;
          state.apiUrlBooking = environmentService.apiUrlBooking;
        },
        setAmmenities(state, payload) {
          state.ammenities = payload;
        },
        setHotelsByUser(state, payload) {
          state.hotelsByUser = payload
        },
        setTotal(state, payload) {
          state.total = payload;
        },
        setHotelsByClient(state, payload) {
          state.hotelsByUser = payload
        },
        setSelectedHotel(state, payload) {
          state.selectedHotel = payload;
        },
        setRoomTypes(state, payload) {
          state.roomtypes = payload;
        },
        setBedOptions(state, payload) {
          state.bedOptions = payload;          
        },
        setCategories(state, payload) {
          state.categories = payload;
        },
        toggleQueryLoading(state, payload){
          state.isLoading = payload;
        },
        toggleHotelLoading(state, payload) {
          state.isHotelLoading = payload;
        },
        toggleHotelReady(state, payload) {
          state.isHotelReady = payload;
        },
        toggleHotelCreate(state, payload) {
          state.isHotelCreate = payload;
        },
        toggleRoomTypeLoading(state, payload) {
          state.isRoomTypeLoading = payload;
        },
        toggleHotelInObservation(state, payload) {
          state.showHotelInObservation = payload;
        },
        insertImage(state, payload){
          state.hotelsByUser[payload.hotelIndex].images.push(payload.image);
        },
        spliceImage(state, payload){
          state.hotelsByUser[payload.hotelPosition].images.splice(payload.imagePosition, 1);
        },
        updateHotelData(state, payload){
          state.hotelsByUser[payload.hotelIndex] = JSON.parse(JSON.stringify(payload.data));
          state.updateFlag += 1;
        },
        updateHotelStatus(state, payload){
          state.hotelsByUser[payload.hotelIndex].closed = payload.closed;
          state.updateFlag += 1;
        },
        updateHotelClientStatus(state, payload){
          state.hotelsByUser[payload.hotelIndex].client_status = payload.closed;
          state.updateFlag += 1;
        },
        updateHotelList(state, payload){
          if (payload.deleted) {
            state.hotelsByUser[payload.hotelIndex].deleted_at = new Date();
          } else {
            state.hotelsByUser[payload.hotelIndex].deleted_at = null;
          }
          state.updateFlag += 1;
        },
        RESET_STATE(state) {
          Object.assign(state, DefaultState());
        },
        RESET_SELECTED_HOTEL(state) {
          state.selectedHotel = null;
        }
      },

      actions = {
        setHotelsUrls({ commit }) {
          commit('setHotelsUrls');
        },
        setGridUpdate({ commit }, payload){
          commit('setGridUpdate', payload);
        },
        setSelectedHotel({ commit }, payload) {
          commit('setSelectedHotel', payload);
        },
        async getHotels({ commit, state, rootState }) {
          // This is the hotel list used in dropdowns,
          // for user with role Hotel only displays related records
          var url = '';
          rootState.auth.user.role.name == 'Hotel' ?
            url = `${state.apiUrlHotel}/hotels/user` :
            url = `${state.apiUrlHotel}/hotels`;

          let records = await getRequestHandler(url, { headers: rootState.auth.headers });
          let payload = [];
          if (url.endsWith('/user')) {
            payload = records.data.data.map(hotel => {
              return {
                name: hotel.name,
                id: hotel.id
              };
            });
          } else {
            payload = records;
          }
          commit('setHotels', payload);
        },

          async getHotelsByUser({ commit, state, rootState}, hotelPayload = {}) {  
          commit('toggleHotelLoading', true);
          let url = `${state.apiUrlHotel}/hotels/user/hotel_client_status`;
          let response = await postRequestHandler(url, hotelPayload, { headers: rootState.auth.headers });
          const is_paginated = hotelPayload.is_paginated || false;
          if(is_paginated){
            let AllHotels = response.data.data || [];
            commit('setHotelsByUser', AllHotels);
            commit('setTotal', response.data.total || 0);
          }else{
            let AllHotels = response.data || [];
            commit('setHotelsByUser', AllHotels);
          }
          commit('toggleHotelLoading', false);
          commit('toggleHotelReady', true);
        },

        async getHotelsByClient({ commit, state, rootState }, hotelPayload = {}) {
          commit('toggleHotelLoading', true);
          let url = `${state.apiUrlHotel}/hotels/client`;
          let response = await postRequestHandler(url, hotelPayload,{headers: rootState.auth.headers});
          const is_paginated = hotelPayload.is_paginated || false;
          
          if(is_paginated){
            let allHotels = response.data.data || [];
            commit('setHotelsByClient', allHotels);
            commit('setTotal', response.data.total || 0);
          }else{
            let allHotels = response.data || []
            commit('setHotelsByClient', allHotels);
          }
          commit('toggleHotelLoading', false);
          commit('toggleHotelReady', true);
        },

        async getChildsPoliciesByHotel({ commit, state, rootState }, payload) {
          let childpolicies = await getRequestHandler(`${state.apiUrlHotel}/childpolicies`, payload, { headers: rootState.auth.headers });
          commit('setChildsPolicies', childpolicies);
        },

        async getAmmenities({ commit, state, rootState }) {
          let payload = await getRequestHandler(`${state.apiUrlHotel}/ammenities`, { headers: rootState.auth.headers });
          commit('setAmmenities', payload);
        },

        async getCategories({ commit, state, rootState }) {
          let payload = await getRequestHandler(`${state.apiUrlHotel}/hotels/categories`, { headers: rootState.auth.headers });
          commit('setCategories', payload);
        },

        async getRoomTypesByHotel({ commit, state, rootState }, payload) {
          let rooms = await postRequestHandler(`${state.apiUrlHotel}/hotels/roomtypes`, payload, { headers: rootState.auth.headers });
          commit('toggleRoomTypeLoading', false);
          commit('setRoomTypes', rooms.roomtypes);
          commit('toggleRoomTypeLoading', false);
          commit('toggleHotelLoading', false);
        },

        async getBedOptions({ commit, state, rootState }) {
          let payload = await getRequestHandler(`${state.apiUrlHotel}/roomtypes/bedoptions`, { headers: rootState.auth.headers });
          commit('setBedOptions', payload);
        },

        async updateHotelInformation({ commit, dispatch, state, rootState }, payload){
          i18n.locale = rootState.global.locale;
          commit('toggleQueryLoading', true);
          if (payload.ammenities.length){
            const hotelUpdated = await postRequestHandler(`${state.apiUrlHotel}/hotels/update`, payload.hotelInformation, { headers: rootState.auth.headers });
            commit('toggleQueryLoading', false);
            if(hotelUpdated.data.status==200){
              dispatch('ammenitiesUpdate', {hotelId: payload.hotelInformation.hotelId, ammenityIds:payload.ammenities});
              dispatch('global/setToastNotification', {text: i18n.t('lang.store.hotels.updateInfoSuccess'), type: 'success', title: i18n.t('lang.store.hotels.hotel')}, {root: true});
              const hotelIndex = state.hotelsByUser.findIndex(hotel => hotel.id == hotelUpdated.data.data.id);
              commit('updateHotelData', {hotelIndex, data: hotelUpdated.data.data});
            }else{
              var error = "";
              hotelUpdated.data.errors.forEach(element => {
                error = error +"<br>"+element;
              });
              dispatch('global/setToastNotification', {text:  i18n.t(`lang.store.hotels.${hotelUpdated.data.errors[0]}`), type: 'error', title: i18n.t('lang.store.hotels.hotel')}, {root: true});
            }
            commit('setUpdateHotelFinished', true);
          } else {
            dispatch('global/setToastNotification', {text:i18n.t('lang.store.hotels.ammenitiesError'), type: 'warning', title:i18n.t('lang.store.hotels.hotel')}, {root: true});
          }

        },
        async ammenitiesUpdate({ commit, dispatch, state, rootState }, payload) {
          commit('toggleQueryLoading', false);
          const ammenitiesUpdated = await postRequestHandler(`${state.apiUrlHotel}/hotels/ammenities/update`, payload, { headers: rootState.auth.headers });
        },
        async updateHotelContact({ commit, dispatch, state, rootState }, payload) {
          i18n.locale = rootState.global.locale;
          const hotelIndex = state.hotelsByUser.findIndex(hotel => hotel.id ==  payload.hotelId);
          const checkNotifications = state.hotelsByUser[hotelIndex].contacts.filter(contact => contact.notification == true);
          if (checkNotifications.length > 0 || payload.contacts[0].notification) {
            const contactUpdated = await postRequestHandler(`${state.apiUrlHotel}/hotels/contacts/update`, payload, { headers: rootState.auth.headers });
            if (contactUpdated.status == 200) {
              commit('setContactListUpdate', contactUpdated.data.contacts);
              dispatch('global/setToastNotification', {text: i18n.t('lang.store.hotels.contactUpdateSuccess'), type: 'success', title:i18n.t('lang.store.hotels.hotel')}, {root: true});
            } else {
              let error = "";
              contactUpdated.errors.forEach(element => {
                error = error +"<br>"+element;
              });
              dispatch('global/setToastNotification', {text:error, type: 'danger', title:i18n.t('lang.store.hotels.hotel')}, {root: true});
            }
          } else {
            dispatch('global/setToastNotification', {text:i18n.t('lang.store.hotels.contactNotificationEnabled'), type: 'danger', title:i18n.t('lang.store.hotels.hotel')}, {root: true});
          }
        },
        async createHotelInformation({ commit, dispatch, state, rootState}, payload){
          i18n.locale = rootState.global.locale;
          const createdHotel = await postRequestHandler(`${state.apiUrlHotel}/hotels/create`, payload.hotel, { headers: rootState.auth.headers });
          if (createdHotel.data.status== 200){
            commit('setHotelCreation', createdHotel.data.data.id);
            dispatch('global/setToastNotification', {text: i18n.t('lang.store.hotels.newHotelSuccess'), type: 'success', title:i18n.t('lang.store.hotels.hotel')}, {root: true});
            dispatch('getHotelsByUser');
          }else{
            var error = "";
            createdHotel.data.errors.forEach(element => {
              error = error +"<br>"+element;
            });
            dispatch('global/setToastNotification', {text: i18n.t(`lang.store.hotels.${createdHotel.data.errors[0]}`), type: 'danger', title:i18n.t('lang.store.hotels.hotel')}, {root: true});
          }
          commit('toggleQueryLoading', false);
        },
        async createHotelContact({ commit, dispatch, state, rootState}, payload){
          i18n.locale = rootState.global.locale;
          const contactCreated = await postRequestHandler(`${state.apiUrlHotel}/hotels/contacts/create`, payload, { headers: rootState.auth.headers });
          commit('toggleQueryLoading', false);
          if (contactCreated.status==200){
            dispatch('global/setToastNotification', {text: i18n.t('lang.store.hotels.contactCreateSuccess'), type: 'success', title:i18n.t('lang.store.hotels.hotel')}, {root: true});
            commit('setContactListUpdate', contactCreated.data.contacts);
          } else {
            let error = contactCreated.errors.map(error => errors += error);
            dispatch('global/setToastNotification', {text:error, type: 'danger', title:i18n.t('lang.store.hotels.hotel')}, {root: true});
          }
        },
        async deleteHotelContact({ commit, dispatch, state, rootState}, payload) {
          i18n.locale = rootState.global.locale;
          const contactDeleted = await postRequestHandler(`${state.apiUrlHotel}/hotels/contacts/delete`, payload, { headers: rootState.auth.headers });
          if (contactDeleted.status==200){
            commit('setContactListUpdate', contactDeleted.data.contacts);
            dispatch('global/setToastNotification', {text:i18n.t('lang.store.hotels.contactDeleteSuccess'), type: 'success', title:i18n.t('lang.store.hotels.hotel')}, {root: true});
          }else{
            var error = "";
            contactDeleted.errors.forEach(element => {
              error = error +"<br>"+element;
            });
            dispatch('global/setToastNotification', {text: error, type: 'danger', title:i18n.t('lang.store.hotels.hotel')}, {root: true});
          }
        },
        async createRoomType({ commit, state, dispatch, rootState}, payload){
          i18n.locale = rootState.global.locale;
          const result = await postRequestHandler(`${state.apiUrlHotel}/roomtypes/create`, payload, { headers: rootState.auth.headers });

          if(result.status == 200){
            dispatch('global/setToastNotification', {title: i18n.t('lang.store.hotels.roomType'), text: i18n.t('lang.store.hotels.roomtypeCreateSuccess'), type:'success'}, {root: true});
            commit('setGridUpdate', true);
            dispatch('getRoomTypesByHotel', {hotelIds: [state.selectedHotel]});
          }else{
            var error = "";
            result.errors.forEach(element => {
              error = error +"<br>"+element;
            });
            dispatch('global/setToastNotification', {title: i18n.t('lang.store.hotels.roomType'), text: error, type:'danger'}, {root: true});
          }
        },
        async updateRoomType({ commit, state, dispatch, rootState}, payload) {
          i18n.locale = rootState.global.locale;
          let roomType = {
            hotel_id : payload.hotel_id,
            roomtypeId : payload.roomtypeId,
            name : payload.name,
            description : payload.description,
            guests : payload.guests,
            additionals : payload.additionals,
            max_occupancy : payload.max_occupancy,
            size: payload.size,
            bedoptions_id: payload.bedoptions_id,
          };

          const result = await postRequestHandler(`${state.apiUrlHotel}/roomtypes/update`, roomType, { headers: rootState.auth.headers});
          if(result.status == 200){
            dispatch('global/setToastNotification', {title: i18n.t('lang.store.hotels.roomType'), text: i18n.t('lang.store.hotels.roomtypeUpdateSuccess'), type:'success'}, {root: true});
            commit('setGridUpdate', true);
            dispatch('getRoomTypesByHotel', {hotelIds: [state.selectedHotel]});
          }else{
            var error = "";
            result.errors.forEach(element => {
              error = error +"<br>"+element;
            });
            dispatch('global/setToastNotification', {title: i18n.t('lang.store.hotels.roomType'), text: error, type:'danger'}, {root: true});
          }
        },
        async requestCloseHotel({commit, state, dispatch, rootState}, payload) {
          i18n.locale = rootState.global.locale;
          const result = await postRequestHandler(`${state.apiUrlHotel}/hotels/close`, payload, { headers: rootState.auth.headers });
          const text = payload.closed ? i18n.t('lang.store.hotels.hotelClosing') : i18n.t('lang.store.hotels.hotelOpening');
          if (result.status != 200) {
            dispatch('global/setToastNotification', {text: i18n.t('lang.store.hotels.closeFail'), type: 'danger', title: i18n.t('lang.store.hotels.hotel')}, {root: true});
          } else {
            const hotelIndex = state.hotelsByUser.findIndex(hotel => hotel.id == payload.hotelId);
            if (hotelIndex >= 0) {
              commit('updateHotelStatus', {hotelIndex, closed:payload.closed});
            }
            dispatch('global/setToastNotification', {text, type: 'success', title:i18n.t('lang.store.hotels.hotel')}, {root: true});
          }

          const isAdmin = rootState.auth.user && rootState.auth.user.role && rootState.auth.user.role.code == 'ADM';
          if (result.status == 200 && !isAdmin && result.errors && result.errors.length > 0) {
            dispatch('global/setDialogAlert', {text: result.errors[0], type: 'danger', title: i18n.t('lang.store.hotels.hotel')}, {root: true});
          }
          return result;
        },
        async getActiveBookingsByHotel({ state, rootState }, hotelId) {
          if (!state.apiUrlBooking) {
            state.apiUrlBooking = environmentService.apiUrlBooking;
          }
          try {
            const response = await axios.post(
              `${state.apiUrlBooking}/bookings/byhotel`,
              { hotelId },
              { headers: rootState.auth.headers }
            );
            return response.data.status == 200 ? response.data.data || [] : [];
          } catch (error) {
            return [];
          }
        },
        async requestCloseHotelStatus({commit, state, dispatch, rootState}, payload) {
          i18n.locale = rootState.global.locale;
          const result = await postRequestHandler(`${state.apiUrlHotel}/hotels/client/close`, payload, { headers: rootState.auth.headers });
          const text = payload.closed ? i18n.t('lang.store.hotels.hotelOpening') : i18n.t('lang.store.hotels.hotelClosing');
          dispatch('global/setToastNotification', {text, type: 'success', title:i18n.t('lang.store.hotels.hotel')}, {root: true});

          if (result.status != 200) {
            dispatch('global/setToastNotification', {text: i18n.t('lang.store.hotels.closeFail'), type: 'danger', title: i18n.t('lang.store.hotels.hotel')}, {root: true});
          } else {
            const hotelIndex = state.hotelsByUser.findIndex(hotel => hotel.id == payload.hotelId);
            commit('updateHotelClientStatus', {hotelIndex, closed:payload.closed});
          }

          if (result.status == 200 && result.errors.length >0) {
            dispatch('global/setDialogAlert', {text: result.errors[0], type: 'danger', title: i18n.t('lang.store.hotels.hotel')}, {root: true});
          }
        },
        async requestDeleteHotel({commit, state, dispatch, rootState}, payload) {
          i18n.locale = rootState.global.locale;
          const result = await postRequestHandler(`${state.apiUrlHotel}/hotels/delete`, payload, { headers: rootState.auth.headers });
          dispatch('global/setToastNotification', {text: i18n.t('lang.store.hotels.deletingHotel'), type: 'success', title:i18n.t('lang.store.hotels.hotel')}, {root: true});

          if (result.status != 200) {
            dispatch('global/setDialogAlert', {text:result.errors[0], type: 'danger', title:i18n.t('lang.store.hotels.hotel')}, {root: true});
          }

          if (result.status == 200) {
            const hotelIndex = state.hotelsByUser.findIndex(hotel => hotel.id == payload.hotelId);
            commit('updateHotelList', {hotelIndex, deleted:true});
            dispatch('global/setToastNotification', {text:  i18n.t('lang.store.hotels.hotelDeleteSuccess'), type: 'danger', title:i18n.t('lang.store.hotels.hotel')}, {root: true});
          }
        },
        async requestRestoreHotel({commit, state, dispatch, rootState}, payload) {
          i18n.locale = rootState.global.locale;
          const result = await postRequestHandler(`${state.apiUrlHotel}/hotels/deleted/restore`, payload, { headers: rootState.auth.headers });
          dispatch('global/setToastNotification', {text:  i18n.t('lang.store.hotels.restoringHotel'), type: 'success', title:i18n.t('lang.store.hotels.hotel')}, {root: true});

          if (result.status != 200) {
            dispatch('global/setDialogAlert', {text:result.errors[0], type: 'danger', title:i18n.t('lang.store.hotels.hotel')}, {root: true});
          }

          if (result.status == 200) {
            const hotelIndex = state.hotelsByUser.findIndex(hotel => hotel.id == payload.hotelId);
            commit('updateHotelList', {hotelIndex, deleted:false});
            dispatch('global/setToastNotification', {text:  i18n.t('lang.store.hotels.hotelRestoreSuccess'), type: 'success', title:i18n.t('lang.store.hotels.hotel')}, {root: true});
          }
        },
        async imageHandler({ commit, state, dispatch, rootState}, payload) {
          i18n.locale = rootState.global.locale;
          const headers = rootState.auth;
          const imagesData = await postRequestHandler(`${state.apiUrlHotel}/hotels/images/${payload.action}`, payload.data, { headers: payload.action == 'create' ? headers.headersWithFile : headers.headers });
          const hotelIndex = state.hotelsByUser.findIndex(hotel => hotel.id == payload.hotelId);
          if (imagesData.data.status == 200) {
            if (payload.action == 'delete') {
              const hotelPosition = state.hotelsByUser.findIndex(hotel => hotel.id == payload.data.hotelId);
              const imagePosition = state.hotelsByUser[hotelPosition].images.findIndex(image => image.id == payload.data.imageIds[0]);
              const updatesPrimary = state.hotelsByUser[hotelPosition].images[imagePosition].is_primary;
              commit('spliceImage', {hotelPosition, imagePosition});
              commit('setImagePrimaryUpdate', {hotelId: payload.data.hotelId, imageId:payload.data.imageIds[0]});
              if (updatesPrimary) {
                if (state.selectedHotel.images.length > 0) {
                  dispatch('imagePrimary',{data: {hotelId: state.selectedHotel.id, imageId: state.selectedHotel.images[0].id, 'type': 1}});

                }
                commit('updatesPrimary', hotelPosition);
              }
            }
            commit('setImageUpdate', { action:payload.action, data: imagesData });

            if (payload.from == 'newHotel') {
              commit('insertImage', {hotelIndex, image: imagesData.data.data});
            }
          } else {
            dispatch('global/setToastNotification', {text: i18n.t('lang.store.hotels.imagesFail'), type: 'danger', title:i18n.t('lang.store.hotels.hotel')}, {root: true});
          }
          commit('toggleUploading', false);
        },
        async imagePrimary({ commit, state, dispatch, rootState}, payload){
          if(payload.data.type == 1){
            const headers = rootState.auth;
            const imagesData = await postRequestHandler(`${state.apiUrlHotel}/hotels/images/setprimary`, payload.data, { headers: headers.headers });
            commit('setImagePrimaryUpdate', payload.data);
          }
          commit('toggleUploading', false);
        },
        async getRatesCheck({commit, dispatch, state, rootState}, payload){
          i18n.locale = rootState.global.locale;
          if (!state.apiUrlHotel) {
            commit('setApiUrls');
          }
          dispatch('global/setToastNotification', {title: i18n.t('lang.store.hotels.roomType'), text: i18n.t('lang.store.hotels.relatedMsg'), type:'success'},{ root: true });
          const rpId = {roomtypeId: payload.roomtypeId};
          const results =  await postRequestHandler(`${state.apiUrlHotel}/roomtypes/check`, rpId, { headers: rootState.auth.headers});
          if (results.status == 200) {
            if (results.data.count) {
              Dialog.confirm({
                title: i18n.t('lang.store.hotels.roomType', [payload.name]),
                message: `
                <div class="container">
                <p class="has-text-weight-bold is-size-5">${i18n.t('lang.store.rateplans.period', [results.data.start_date, results.data.end_date])}</p>
                <br>
                <h4 class="title is-5" style="text-align:center">${i18n.t('lang.store.rateplans.count', [results.data.count])}</h5>
                <br>
                <p class="is-italic">(*)${i18n.t('lang.store.rateplans.comment', ['<br/>'])} </p>
                </div>
                `,
                confirmText: i18n.t('lang.store.confirm'),
                cancelText: i18n.t('lang.store.cancel'),
                type: 'is-danger',
                hasIcon: true,
                onConfirm: () => dispatch('deleteRoomtype', rpId)
              })
            } else {
              Dialog.confirm({
                title: i18n.t('lang.store.rateplans.deletionTitle', [payload.name]),
                message: `${i18n.t('lang.RoomTypes.noRoom')}`,
                confirmText: i18n.t('lang.store.confirm'),
                cancelText: i18n.t('lang.store.cancel'),
                // type: 'is-danger',
                hasIcon: true,
                onConfirm: () => dispatch('deleteRoomtype', rpId)
              })
            }
          }
        },

        async deleteRoomtype({commit, state, dispatch, rootState}, payload){
          i18n.locale = rootState.global.locale;
          const results =  await postRequestHandler(`${state.apiUrlHotel}/roomtypes/delete`, payload, { headers: rootState.auth.headers});
          if (results.status == 200) {
            dispatch('global/setToastNotification', {title: i18n.t('lang.store.roomtypes.roomtypes'), text: i18n.t('lang.store.roomtypes.deleteSuccessRoom'), type:'success'},{ root: true });
            commit('setDeletionSuccess', true);
            commit('setGridUpdate', true);
            dispatch('getRoomTypesByHotel', {hotelIds: [state.selectedHotel]});
          } else {
            dispatch('global/setToastNotification', {title: i18n.t('lang.store.roomtypes.roomtypes'), text:results.errors , type:'danger'},{ root: true });
          }
        },

        async getMarkupByHotel({commit, state, dispatch, rootState}, payload){
          i18n.locale = rootState.global.locale;
          if (!state.apiUrlHotel) {
            commit('setApiUrls');
          }
          const results =  await postRequestHandler(`${state.apiUrlHotel}/hotels/markups`, payload, { headers: rootState.auth.headers});
          if (results.status == 200) {
            return results.data;
          } //else {
          //  dispatch('global/setToastNotification', {title: i18n.t('lang.store.auth.hotelMarkup'), text:results.errors , type:'danger'},{ root: true });
          //}
        },
        async createMarkupByHotel({commit, state, dispatch, rootState}, payload){
          i18n.locale = rootState.global.locale;
          if (!state.apiUrlHotel) {
            commit('setApiUrls');
          }
          const results =  await postRequestHandler(`${state.apiUrlHotel}/hotels/markups/create`, payload, { headers: rootState.auth.headers});
          if (results.status == 200) {
            dispatch('global/setToastNotification', {title: i18n.t('lang.store.auth.hotelMarkup'), text: i18n.t('lang.store.auth.hotelMarkupSuccess'), type:'success'},{ root: true });
            return results.data;
          } else {
            dispatch('global/setToastNotification', {title: i18n.t('lang.store.auth.hotelMarkup'), text:results.errors , type:'danger'},{ root: true });
          }
        },
        async deleteMarkupByHotel({commit, state, dispatch, rootState}, payload){
          i18n.locale = rootState.global.locale;
          if (!state.apiUrlHotel) {
            commit('setApiUrls');
          }
          const results =  await postRequestHandler(`${state.apiUrlHotel}/hotels/markups/delete`, payload, { headers: rootState.auth.headers});
          if (results.status == 200) {
            dispatch('global/setToastNotification', {title: i18n.t('lang.store.auth.hotelMarkup'), text: i18n.t('lang.store.auth.hotelMarkupDeleted'), type:'success'},{ root: true });
            return results.data;
          } else {
            dispatch('global/setToastNotification', {title: i18n.t('lang.store.auth.hotelMarkup'), text:results.errors , type:'danger'},{ root: true });
          }
        },

        async getHotelPenalties({commit, state, dispatch, rootState}, payload){
          i18n.locale = rootState.global.locale;
          if (!state.apiUrlHotel) {
            commit('setApiUrls');
          }
          const results =  await postRequestHandler(`${state.apiUrlHotel}/hotels/penalties`, payload, { headers: rootState.auth.headers});
          if (results.status == 200) {
            return results.data;
          }
        },
        async createHotelPenalty({commit, state, dispatch, rootState}, payload){
          i18n.locale = rootState.global.locale;
          if (!state.apiUrlHotel) {
            commit('setApiUrls');
          }
          const results =  await postRequestHandler(`${state.apiUrlHotel}/hotels/penalties/create`, payload, { headers: rootState.auth.headers});
          if (results.status == 200) {
            dispatch('global/setToastNotification', {title: i18n.t('lang.store.auth.hotelPenalty'), text: i18n.t('lang.store.auth.hotelPenaltySuccess'), type:'success'},{ root: true });
            return results.data;
          } else {
            dispatch('global/setToastNotification', {title: i18n.t('lang.store.auth.hotelPenalty'), text:results.errors , type:'danger'},{ root: true });
          }
        },
        async deleteHotelPenalty({commit, state, dispatch, rootState}, payload){
          i18n.locale = rootState.global.locale;
          if (!state.apiUrlHotel) {
            commit('setApiUrls');
          }
          const results =  await postRequestHandler(`${state.apiUrlHotel}/hotels/penalties/delete`, payload, { headers: rootState.auth.headers});
          if (results.status == 200) {
            dispatch('global/setToastNotification', {title: i18n.t('lang.store.auth.hotelPenalty'), text: i18n.t('lang.store.auth.hotelPenaltyDeleted'), type:'success'},{ root: true });
            return results.data;
          } else {
            dispatch('global/setToastNotification', {title: i18n.t('lang.store.auth.hotelPenalty'), text:results.errors , type:'danger'},{ root: true });
          }
        },

        setSelectedHotel({ commit }, payload) {
          commit('setSelectedHotel', payload);
        },

        toggleHotelInObservation({ commit }, payload) {
          commit('toggleHotelInObservation', payload);
        },
        toggleHotelLoading({ commit }, payload) {
          commit('toggleHotelLoading', payload);
        },

        toggleHotelReady({ commit }, payload) {
          commit('toggleHotelReady', payload);
        },

        toggleRoomTypeLoading({ commit }, payload) {
          commit('toggleRoomTypeLoading', payload);
        },
        RESET_STATE({ commit }) {
          commit('RESET_STATE');
        },
        RESET_SELECTED_HOTEL({ commit }) {
          commit('RESET_SELECTED_HOTEL');
        }
      };

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};



// WEBPACK FOOTER //
// ./src/store/modules/hotels.js